// extracted by mini-css-extract-plugin
export default {"title-user":"MySocialMemoryPdf_title-user__RRXDr"};